module.exports = __webpack_public_path__ + "static/media/400032_02.ba67672a.png";